export const replaceArgsInMessage = (
  localizedMessage: string,
  args: (string | number | boolean)[],
) => {
  args.forEach((arg, i) => {
    localizedMessage = localizedMessage.split(`{${i}}`).join(arg.toString());
  });

  return localizedMessage;
};

export const isNullOrWhiteSpace = (str: string | null | undefined) => {
  return str === null || str === undefined || str.trim().length === 0;
};
